import { EmptyState } from '@/components/custom/empty-state';
import { get } from 'draft-js/lib/DefaultDraftBlockRenderMap';
import { useEffect, useState } from 'react';
import { AiOutlineTrophy } from 'react-icons/ai';
import { FiChevronDown } from 'react-icons/fi';

export function GreTable({ filters, data, setSelectedGre, sortConfig, onSort, getColor }) {
  const [filteredData, setFilteredData] = useState(data?.ranking);

  useEffect(() => {
    if (filters.values.searchTerm.length > 0) {
      const filtered = data?.ranking?.filter(item => item?.['regional_name']?.toLowerCase().includes(filters.values.searchTerm.toLowerCase()));
      setFilteredData(filtered);
    } else {
      setFilteredData(data?.ranking);
    }
  }, [filters.values['searchTerm'], data]);

  return (
    <>
      <div className="report-widget__filter">
        <input
          className="report-form__control report-form__control--md"
          aria-label="Pesquisar"
          placeholder="Pesquisar"
          type="search"
          name="search"
          id="search"
          onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
          disabled={data?.ranking?.length === 0 && filters.values.searchTerm === ''}
        />
      </div>

      <div className="report-widget__body">
        {filteredData?.length === 0 ? (
          <EmptyState
            title="Nenhum dado disponível"
            type="data"
            text="Não há dados a serem exibidos."
            className="my-10"
          />
        ) : (
          <div className="round-dg-wrapper">
            <table
              className="round-dg round-dg--light"
              style={{ minWidth: '720px' }}
            >
              <thead className="round-dg__header">
                <tr className="round-dg__row">
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '80px' }}
                  >
                    Posição
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '50px' }}
                  ></th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-52">GRE</th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-44">
                    Matemática
                    <span
                      onClick={() => onSort('math')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'math' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-44">
                    Ciências Humanas
                    <span
                      onClick={() => onSort('humanities')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'humanities' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-44">
                    Ciências da Natureza
                    <span
                      onClick={() => onSort('natural-sciences')}
                      className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1"
                    >
                      <FiChevronDown
                        style={{ transform: sortConfig.field === 'natural-sciences' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                        className="card__icon"
                      />
                    </span>
                  </th>
                  <th className="round-dg__cell-header round-dg__cell-header--sm w-[180px]">
                    <div className="flex w-full items-center">
                      <span
                        className="flex-1 truncate text-left"
                        title="Linguagens e suas Tecnologias"
                      >
                        Linguagens e suas Tecnologias
                      </span>
                      <span
                        onClick={() => onSort('technology')}
                        className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-1 shrink-0"
                      >
                        <FiChevronDown
                          style={{ transform: sortConfig.field === 'technology' && sortConfig.direction === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
                          className="card__icon"
                        />
                      </span>
                    </div>
                  </th>
                  <th
                    className="round-dg__cell-header round-dg__cell-header--sm"
                    style={{ width: '80px' }}
                  ></th>
                </tr>
              </thead>

              <tbody className="round-dg__body">
                {filteredData?.length > 0 &&
                  filteredData?.map((item, i) => (
                    <tr
                      key={item.id}
                      className={`round-dg__row`}
                    >
                      <td className="round-dg__cell round-dg__cell--sm u-text-right">{i + 1 < 10 ? `0${i + 1}` : i + 1}</td>
                      <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                        {i === 0 && <AiOutlineTrophy className="card__icon card__icon--golden mr-3" />}
                        {i === 1 && <AiOutlineTrophy className="card__icon card__icon--silver mr-3" />}
                        {i === 2 && <AiOutlineTrophy className="card__icon card__icon--bronze mr-3" />}
                      </th>
                      <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row font-semibold text-primary-dark">{item?.['regional_name']}</th>
                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.matematica)}`}>{item?.matematica !== null ? `${item?.matematica.toFixed(2)}%` : '--'}</td>
                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_humanas'])}`}>{item?.['ciencias_humanas'] !== null ? `${item?.['ciencias_humanas'].toFixed(2)}%` : '--'}</td>
                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['ciencias_natureza'])}`}>{item?.['ciencias_natureza'] !== null ? `${item?.['ciencias_natureza'].toFixed(2)}%` : '--'}</td>
                      <td className={`round-dg__cell round-dg__cell--sm ${getColor(item?.['linguagens'])}`}>{item?.['linguagens'] !== null ? `${item?.['linguagens'].toFixed(2)}%` : '--'}</td>
                      <td className="round-dg__cell round-dg__cell--sm">
                        <span
                          onClick={() => {
                            setSelectedGre(item);
                          }}
                          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer ml-2"
                        >
                          <FiChevronDown
                            style={{ transform: 'rotate(270deg)' }}
                            className="card__icon"
                          />
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
